import { Grid } from '../../../grid/grid';
import { Text, TextProps } from '../../../text/text.component';

import { QuoteIcon } from './quote-icon';
import {
  QuoteCarouselItemQuoterProps,
  QuoteCarouselItemQuoter,
} from '../quote-carousel-item-quoter/quote-carousel-item-quoter';

export interface QuoteProps extends QuoteCarouselItemQuoterProps {
  quote?: TextProps;
}

export const Quote = ({ quote, logo, person, titleOfPerson }: QuoteProps) => {
  return (
    <div className="snowflake-quote-carousel-item snowflake-container">
      <div data-testid="snowflake-quote-carousel-item-quote">
        <Grid container className="snowflake-quote-carousel-item-quote">
          <Grid
            item
            className="snowflake-quote-carousel-item-quote-left-icon"
            mobile={12}
            tablet={12}
            smallDesktop={2}
            desktop={2}
          >
            <QuoteIcon />
          </Grid>
          {quote && (
            <Grid
              className="snowflake-quote-carousel-item-quote-text"
              item
              mobile={12}
              tablet={10}
              smallDesktop={8}
              desktop={8}
            >
              <div
                className="snowflake-quote-carousel-item-quote-text"
                data-testid="snowflake-quote-carousel-item-quote-text"
              >
                <Text {...quote} />
              </div>
            </Grid>
          )}
          <Grid
            className="snowflake-quote-carousel-item-quote-right-icon"
            item
            mobile={12}
            tablet={12}
            smallDesktop={2}
            desktop={2}
          >
            <QuoteIcon isInverse />
          </Grid>
        </Grid>
      </div>
      <QuoteCarouselItemQuoter logo={logo} person={person} titleOfPerson={titleOfPerson} />
    </div>
  );
};
